import { asArray } from '../utilities/utils'

export default class EditableHeading {

    private static EVENTS: Array<string> = ['keyup', 'change']
    private IE_CLASS: string = 'updated-for-ie'
    private MAXLENGTH: string = 'maxlength'

    private editableHeadings: Array<HTMLDivElement> = asArray(document.getElementsByClassName('editable-heading'))

    public initialiseEditableHeading(): void {
        this.editableHeadings.forEach((heading: HTMLDivElement) => {
            const input: HTMLInputElement = heading.querySelector('input')
            const pseudoElement: HTMLHRElement = heading.querySelector('hr')

            if (input.hasAttribute(this.MAXLENGTH)) {
                if (input.value != undefined) {
                    pseudoElement.dataset.remainingIe = (parseInt(input.getAttribute(this.MAXLENGTH), 10) - input.value.length).toString()
                    pseudoElement.classList.toggle(this.IE_CLASS)
                }

                EditableHeading.EVENTS.forEach((event: string) => input.addEventListener(event, $e => {
                    let remaining: number = 0

                    if (input.value != undefined) {
                        remaining = parseInt(input.getAttribute(this.MAXLENGTH), 10) - input.value.length
                    }

                    pseudoElement.dataset.remaining = remaining.toString()
                    pseudoElement.dataset.remainingIe = remaining.toString()
                    pseudoElement.classList.toggle(this.IE_CLASS)

                    if (($e as KeyboardEvent).keyCode === 13) {
                        input.classList.add('shake')

                        setTimeout(() => input.classList.remove('shake'), 200)
                    }
                }))
            }
        })
    }

    public static newInstance(): EditableHeading {
        return new EditableHeading()
    }
}